<template>
  <div >
    <m1-geo-box v-if="uiVersion === 1"
                :geoOption="geoOption" :title="title" :goNext="goNext"
                :needNext="needNext" @go="$emit('go')">
      <slot />
      <template slot="button-content">
        <slot name="button-content">
        </slot>
      </template>
    </m1-geo-box>

    <m2-geo-box  v-if="uiVersion === 2" :geoOption="geoOption">
      <slot></slot>
    </m2-geo-box>


  </div>
</template>

<script>
  import M1GeoBox from '@/components/geo/M1GeoBox'
  import M2GeoBox from '@/components/geo/M2GeoBox'

  export default {
    components: {
      M1GeoBox,
      M2GeoBox
    },
    props: {
      geoOption: {
        type: String,
        default: ''
      },
      title: {
        type: String
      },
      goNext: {
        type: Number,
        default: 0
      },
      needNext: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      uiVersion () {
        return this.$store.state.config.uiVersion
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/geo/MGeoBox.vue